import { render, staticRenderFns } from "./Capture2.vue?vue&type=template&id=925af28e"
import script from "./Capture2.vue?vue&type=script&lang=js"
export * from "./Capture2.vue?vue&type=script&lang=js"
import style0 from "./Capture2.vue?vue&type=style&index=0&id=925af28e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports